<template>
	<div>
		<triangle-image
			title="Scopri i nuovi Tortellini di carne non carne"
			subtitle="La tradizione che incontra una soluzione moderna e sostenibile"
		/>

		<div class="container">
			<div class="content">
				<section class="paragraph">
					<h2>
						Cosa sono i Tortellini di carne non carne
					</h2>

					<p>
						La carne del futuro è arrivata anche in Italia. Avrete forse sentito parlare delle nuove soluzioni <b>“meatless”</b>, prodotti che all’aspetto e al gusto si avvicinano davvero tanto alla carne animale ma che sono in realtà interamente realizzati con <b>proteine vegetali</b>. Hamburger, salsicce, hot dog e ora in esclusiva su Quomi anche uno dei grandi classici della tradizione culinaria italiana: <b>i tortellini</b>.
					</p>

					<h2>
						Prodotti a marchio Quomi
					</h2>

					<p>
						Questo prodotto, <b>nasce da un’analisi attenta delle esigenze alimentari dei nostri clienti</b>, che Quomi ha deciso di soddisfare grazie all’ideazione di nuove soluzioni, altamente profilate e di qualità. Tutti i prodotti a marchio Quomi nascono da un intenso lavoro di ricerca e sviluppo e cercano sempre di avere come obiettivi <b>gusto, qualità e sostenibilità ambientale</b>.

						<br><br>

						Perché sì, <b>la carne non carne</b> nasce proprio dalla volontà di <b>ridurre al minimo l’impatto ambientale</b> generato dagli allevamenti, mantenendo un’etichetta semplice, con pochi ingredienti tutti vegetali, e portando allo stesso tempo in tavola il gusto e la consistenza di uno dei prodotti più consumati al mondo.
					</p>

					<h2>
						Prova una novità in cucina
					</h2>

					<p>
						Le ricette che includono <b>i tortellini di carne non carne</b> saranno disponibili su Quomi già nelle prime settimane di Settembre. Per sperimentare questo nuovo ingrediente in cucina, sarà sufficiente selezionare la ricetta nel menù della settimana per riceverla e gustarla comodamente a casa.
					</p>

					<h2>
						Assapora il gusto unico dei tortellini carne non carne
					</h2>

					<p>
						Scopri le ricette pensate per te da Quomi con i tortellini carne non carne <br>

						Ogni settimana potrai trovare tante novità da introdurre nella tua cucina.
					</p>
					
					<slick>
						<template slot="slides">
							<div class='recipe' v-for="(item, index) in extras" :key="index">
								<img :src="item.images.big" :alt='item.title'>
								<div class="recipe-name">{{ item.title }}</div>
							</div>
						</template>
					</slick>
				</section>

				<router-link
                    :to="{ name: 'recipes' }"
                    class="flex flex-center"
                >
                    <CTA
                    	isStar
                    	color='orange'
                        :content="`Fai ora la tua spesa`"
                    />
                </router-link>	
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import TriangleImage from '../TriangleImage'
	import Slick from '../Slick'
	import { goSlick } from '../../assets/js/slick'

	import { ExtraApi } from '../../api/ExtraApi'
	import { AllRecipesApi } from '../../api/AllRecipesApi'


	export default {
	components: {
		TriangleImage,
		Slick
	},

	data () {
		return {
			extras: null,
			recipeIds: [869, 870]
		}
	},

	computed: {
		user () {
			return this.$root.user
		}
	},

	methods: {
		loadExtras () {
			var ids = this.recipeIds.join(",");

			var recipesApi = new AllRecipesApi()
			return recipesApi.get({
				params: {
	                show: 6,
	                page: 1,
	                sort_direction: 'desc',
	                query: `id in (${ids})`
	            }
            })


			.then(response => {
				this.extras = response.body.data.resources
			})

			.catch(response => {
			})
		}
	},

	mounted () {
		this.loadExtras()

		.then(response => {
			goSlick()
		})
	}

}
</script>

<style scoped>

.slick-slide >>> .recipe-name.small {
	font-size: 12px;
	text-align: left;
	min-height: 55px;
}

.triangle-image {
	background: url("https://api.quomi.it/oldimg/Tortellini-di-carne-non-carne-con-salsa-di-datterini-freschi-e-basilico-thumb-big.jpg");
	background-position: center 8%;
	background-repeat: no-repeat;
	background-size: cover;
}


.content {
	max-width: 800px;
}

.paragraph p {
  margin-bottom: 45px;
}

@media (max-width: 1024px) {
	.triangle-image >>> h1 {
		font-size: 30px;
	}
}

</style>
